document.addEventListener("DOMContentLoaded", function () {
  // Run only on mobile
  if (window.innerWidth > 768) return;

  const sections = document.querySelectorAll('[id^="cnsp-"]');
  if (!sections.length) return;

  // Create unified mobile carousel container
  const wrapper = document.createElement("div");
  wrapper.classList.add("cnsp-mobile-carousel", "owl-carousel", "owl-theme");

  // Clone each section into the new carousel
  sections.forEach((section) => {
    const clone = section.cloneNode(true);
    clone.removeAttribute("id"); // prevent duplicate IDs
    clone.classList.add("cnsp-slide-item");
    wrapper.appendChild(clone);

    // Hide original section
    section.style.display = "none";
  });

  // === FIX: insert carousel directly before the first section ===
  const firstSection = sections[0];
  firstSection.parentNode.insertBefore(wrapper, firstSection);

  // Initialize Owl Carousel
  $(wrapper).owlCarousel({
    items: 1,
    loop: true,
    dots: true,
    nav: true,
    margin: 0,
    autoplay: false,
    smartSpeed: 500,
    navText: [
      `<img src="{{ 'left-arrow.svg' | asset_url }}" alt="Prev" style="width:20px;height:auto;">`,
      `<img src="{{ 'right-arrow.svg' | asset_url }}" alt="Next" style="width:20px;height:auto;">`
    ]
  });

  console.log(
    `[CNSP] Combined ${sections.length} 'Single Product' sections into one mobile carousel and inserted before the first section.`
  );
});
